import { render, staticRenderFns } from "./SurveyImprovementHeader.vue?vue&type=template&id=188bf671&"
import script from "./SurveyImprovementHeader.vue?vue&type=script&lang=js&"
export * from "./SurveyImprovementHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports